"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/SmallLeaflet.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SmallLeaflet = function SmallLeaflet(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 19.1 20"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Small Leaflet Icon"), _react2.default.createElement("path", {
    className: "leaflet",
    d: "M12.56,0L6.08,2.75,0,0V17.26L6,20l6.56-2.77L19.1,20V3.24ZM6,18.51L1.14,16.33V2L6,4.13V18.51Zm6-2.6L7.13,18.09V3.71L12,1.53V15.91Zm6,2.63-4.83-2.18V2L18,4.16V18.54Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = SmallLeaflet;